import { render, staticRenderFns } from "./CategoricalShapleyDependence.vue?vue&type=template&id=ed2bfc76&"
import script from "./CategoricalShapleyDependence.vue?vue&type=script&lang=js&"
export * from "./CategoricalShapleyDependence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports